import { render, staticRenderFns } from "./PointerMenu.vue?vue&type=template&id=76315d07&scoped=true&"
import script from "./PointerMenu.vue?vue&type=script&lang=ts&"
export * from "./PointerMenu.vue?vue&type=script&lang=ts&"
import style0 from "./PointerMenu.vue?vue&type=style&index=0&id=76315d07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76315d07",
  null
  
)

export default component.exports